var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandlordsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99028 10.2308C5.41187 10.2308 3.20996 10.6207 3.20996 12.1819C3.20996 13.7432 5.3979 14.147 7.99028 14.147C10.5687 14.147 12.77 13.7565 12.77 12.1959C12.77 10.6353 10.5827 10.2308 7.99028 10.2308Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98993 8.00396C9.68199 8.00396 11.0534 6.6319 11.0534 4.93983C11.0534 3.24777 9.68199 1.87634 7.98993 1.87634C6.29786 1.87634 4.9258 3.24777 4.9258 4.93983C4.92008 6.62618 6.28262 7.99825 7.96834 8.00396H7.98993Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlordsIcon);
export default __webpack_public_path__ + "static/media/landlordsIcon.e6cb432d52a8f906c6f7f88a27f87864.svg";
export { ForwardRef as ReactComponent };